import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, ToggleButton, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import IconCheckbox from "../../components/Form/IconCheckbox";
import ImageGallery from "../../components/Form/ImageGallery";
import Renderers from "../../helpers/Renderers";
import ButtonToolbar from "../../components/ButtonToolbar";
import immutable from "immutable";
import DocumentList from "../../containers/Document/PickerList";
import {ModalWindow} from 'reactis-modal';
import DocumentSubform from "../../containers/Document/DocumentSubform";

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'forklift.fetch',
			save: 'forklift.save',
			remove: 'forklift.delete'
		};

		this.changeEvent = 'forklift.change';

		this.messages = {
			remove: 'Opravdu si přejete druh odstranit?',
			notfound: 'Druh nenalezen!'
		};

		this.schema = {
			title: {
				class: TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: {message: 'Název je povinná položka!'}
				}
			},
			subtitle: {
				class: TextInput,
				label: 'Popis',
			},
			engine: {
				class: TextInput,
				label: 'Pohon',
			},
			priority: {
				class: Number,
				style: {width: 60},
				label: 'Pozice',
			},
			images: {
				class: ImageGallery,
				label: 'Fotogalerie'
			},
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'title') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.title});
	}


	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Druh vozíku">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					<div className="row">
						<div className="col-xs-8">
							<table className="form">
								<tbody>
									<FormRow name="title" width={100} />
									<FormRow name="subtitle" />
									<FormRow name="engine" />
									<FormRow name="priority" />
									<FormRow name="images" />
									<FormRow className="buttons">
										{saveCloseButton}
									</FormRow>
								</tbody>
							</table>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Forklift/Form.js